'use client';

import type { SourceType, VerificationStatus } from '@/types/firestore';
import { SOURCE_TYPE_LABEL } from '@/lib/constants';
import TrustBadge from '@/components/trust/TrustBadge';
import VerificationTag from '@/components/trust/VerificationTag';

interface SourceBadgeProps {
  authorityTier?: number;
  sourceType?: SourceType;
  verificationStatus?: VerificationStatus;
  size?: 'sm' | 'md';
}

export default function SourceBadge({ authorityTier, sourceType, verificationStatus, size = 'sm' }: SourceBadgeProps) {
  // sourceType이 없으면 기존 문서이므로 배지 표시 안 함
  if (!sourceType) return null;

  if (size === 'sm') {
    return <TrustBadge authorityTier={authorityTier} sourceType={sourceType} size="sm" />;
  }

  // md: 상세 페이지용 — 신뢰등급 + 출처종류 + 검증 상태
  return (
    <div className="flex flex-wrap items-center gap-2">
      <TrustBadge authorityTier={authorityTier} sourceType={sourceType} size="md" />
      {/* 출처종류 배지 (기존과 동일) */}
      <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium bg-gray-50 text-gray-600 border border-gray-200">
        {SOURCE_TYPE_LABEL[sourceType]}
      </span>
      {/* 검증 상태: VerificationTag로 대체 */}
      {verificationStatus && verificationStatus !== 'unverified' && (
        <VerificationTag verificationStatus={verificationStatus} />
      )}
    </div>
  );
}
